import { useEffect } from 'react';

import type { FieldValues, UseFormReset } from 'react-hook-form';

type UseResetFormWhenReadyParams<T extends FieldValues> = {
  /** 쿼리 성공·데이터 존재 등 reset을 호출해도 될 때 true */
  ready: boolean;
  reset: UseFormReset<T>;
  /** `reset`에 넘길 스냅샷. 준비 전이면 null */
  values: T | null;
};

/**
 * 모달이 열려 있고 `ready`일 때 `values`로 폼을 동기화한다. 서버 조회 결과를 폼에 주입할 때 사용한다.
 */
const useResetFormWhenReady = <T extends FieldValues>(
  params: UseResetFormWhenReadyParams<T>,
): void => {
  const { ready, reset, values } = params;

  useEffect(() => {
    if (!ready || !values) {
      return;
    }
    reset(values);
  }, [ready, reset, values]);
};

export default useResetFormWhenReady;
